import { createRouter, createWebHistory } from 'vue-router';
import { useStore } from 'vuex';
import jwt_decode from 'jwt-decode';

const routes = [
  {
    path: '/',
    component: () => import('../App.vue'),
    meta: { requiresAuth: false, title: '磐诺全景 ★无人机全景导览~' },
    children: [
      {
        path: '',
        component: () => import('../components/Main.vue'),
        meta: { requiresAuth: false, title: '磐诺全景 ★无人机全景导览~' },
      },
    ],
  },
  // 音频管理系统
  {
    path: '/accumulation',
    component: () => import('../components/accumulation/AudioMain.vue'),
    meta: { requiresAuth: true, title: '音频管理系统' ,favicon: '/audio_favicon.jpg'},
    children: [
      {
        path: 'audio-list',
        component: () => import('../components/accumulation/audiolist/AudiolistMain.vue'),
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'list',
        component: () => import('../components/accumulation/audiolist/AudioList.vue'),
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'audiolist/subtitle-edit/:id',
        component: () => import('../components/accumulation/audiolist/components/SubtitleEdit.vue'),
        meta: { requiresAuth: true, title: '字幕编辑' },
      },
      {
        path: 'collectionlist',
        component: () => import('../components/accumulation/collectionlist/AudioCollectionList.vue'),
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'userlist',
        component: () => import('../components/platform/userlist/UserList.vue'), 
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'qulearning',
        component: () => import('../components/accumulation/qulearning/QuAudiolistMain.vue'),
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'qucollectionlist',
        component: () => import('../components/accumulation/quCollectionlist/QuAudioCollectionList.vue'),
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'article-manage',
        component: () => import('../components/accumulation/articleManage/ArticleManagePage.vue'),
        meta: { requiresAuth: true, title: '课文管理' },
      },
      {
        path: 'quaudios',
        component: () => import('../components/accumulation/quaudios/quaudioslist.vue'),
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'aitools',
        component: () => import('../components/accumulation/aItools/aitools.vue'),
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'rolelist',
        component: () => import('../components/platform/userlist/RoleList.vue'), 
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
      {
        path: 'menulist',
        component: () => import('../components/platform/userlist/MenuList.vue'), 
        meta: { requiresAuth: true, title: '音频管理系统' },
      },
             {
         path: 'dictionary',
         component: () => import('../components/platform/userlist/DictionaryManage.vue'), 
         meta: { requiresAuth: true, title: '字典管理' },
       },
       {
        path: 'airole',
        component: () => import('../components/platform/userlist/AIRolesManage.vue'), 
        meta: { requiresAuth: true, title: 'AI角色配置' },
      },
      {
        path: 'material-manage',
        component: () => import('../components/accumulation/qumaterialmanage/QuMaterialManage.vue'),
        meta: { requiresAuth: true, title: '资料管理' },
      },
      {
        path: 'banner-manage',
        component: () => import('../components/accumulation/bannermanage/BannerManage.vue'),
        meta: { requiresAuth: true, title: 'Banner管理' },
      },
      {
        path: 'bg-images-manage',
        component: () => import('../components/accumulation/pub/BgImagesManage.vue'),
        meta: { requiresAuth: true, title: '背景图库管理' },
      },
      {
        path: 'treehole-manage',
        component: () => import('../components/accumulation/treehole/TreeholeManage.vue'),
        meta: { requiresAuth: true, title: '树洞管理' },
      },
      {
        path: 'article-series',
        component: () => import('../components/accumulation/articleseries/ArticleSeriesManage.vue'),
        meta: { requiresAuth: true, title: '教材系列管理' },
      },
      {
        path: 'audio-series',
        component: () => import('../components/accumulation/audioseries/AudioSeriesManage.vue'),
        meta: { requiresAuth: true, title: '音频系列管理' },
      },
      // 视频管理系列
      {
        path: 'videoseries',
        component: () => import('../components/accumulation/videoserieslist/VideoSeriesList.vue'),
        meta: { requiresAuth: true, title: '视频系列管理' },
      },
      // 视频合集管理
      {
        path: 'videocollection',
        component: () => import('../components/accumulation/videocollectionlist/VideoCollectionList.vue'),
        meta: { requiresAuth: true, title: '视频合集管理' },
      },
      // 视频列表管理
      {
        path: 'videolist',
        component: () => import('../components/accumulation/videolist/VideoList.vue'),
        meta: { requiresAuth: true, title: '视频列表管理' },
      },
      // 电子书管理
      {
        path: 'book-series',
        component: () => import('../components/accumulation/bookseries/BookSeriesList.vue'),
        meta: { requiresAuth: true, title: '电子书系列管理' },
      },
      {
        path: 'book-list',
        component: () => import('../components/accumulation/booklist/BookList.vue'),
        meta: { requiresAuth: true, title: '电子书管理' },
      },
      {
        path: 'order-manage',
        component: () => import('../components/accumulation/ordermanage/OrderManage.vue'),
        meta: { requiresAuth: true, title: '订单管理' },
      },
      {
        path: 'camp-manage',
        component: () => import('../components/accumulation/campmanage/CampManage.vue'),
        meta: { requiresAuth: true, title: '训练营管理' },
      },
      {
        path: 'question-bank',
        component: () => import('../components/accumulation/questionbank/QuestionBankList.vue'),
        meta: { requiresAuth: true, title: '完形填空题库' },
      },
      {
        path: 'payout-manage',
        component: () => import('../components/accumulation/paymanage/PayoutManage.vue'),
        meta: { requiresAuth: true, title: '支付管理' },
      },
      {
        path: 'hotspot-list',
        component: () => import('../components/accumulation/pointreading/hotspotlist.vue'),
        meta: { requiresAuth: true, title: '热点编辑' },
      },
      {
        path: 'feedback-list',
        component: () => import('../components/accumulation/feedback/FeedbackList.vue'),
        meta: { requiresAuth: true, title: '反馈管理' },
      },
      {
        path: 'version-config',
        component: () => import('../components/accumulation/version/VersionConfigList.vue'),
        meta: { requiresAuth: true, title: '版本配置管理' },
      },
      {
        path: 'notification-manage',
        component: () => import('../components/accumulation/notificationmanage/NotificationManage.vue'),
        meta: { requiresAuth: true, title: '消息通知管理' },
      },
      {
        path: 'announcement-manage',
        component: () => import('../components/accumulation/announcementmanage/AnnouncementManage.vue'),
        meta: { requiresAuth: true, title: '公告管理' },
      },
      {
        path: 'promoter-list',
        component: () => import('../components/accumulation/promoter/PromoterList.vue'),
        meta: { requiresAuth: true, title: '达人审核' },
      },
      {
        path: 'member-list',
        component: () => import('../components/accumulation/member/MemberList.vue'),
        meta: { requiresAuth: true, title: '会员管理' },
      },
      {
        path: 'blacklist',
        component: () => import('../components/accumulation/blacklist/BlacklistManagement.vue'),
        meta: { requiresAuth: true, title: '黑名单管理' },
      },
      {
        path: 'medal-manage',
        component: () => import('../components/accumulation/medalmanage/MedalManage.vue'),
        meta: { requiresAuth: true, title: '勋章管理' },
      },
      {
        path: 'product-manage',
        component: () => import('../components/accumulation/productmanage/ProductManage.vue'),
        meta: { requiresAuth: true, title: '商品管理' },
      },
      {
        path: 'error-log',
        component: () => import('../components/accumulation/errorlog/ErrorLogManage.vue'),
        meta: { requiresAuth: true, title: '前端错误日志' },
      }
    ],
  },
  {
    path: '/accumulation/login',
    component: () => import('../components/accumulation/Login.vue'),
    meta: { requiresAuth: false, title: '系统登录页' },
  },
  {
    path: '/accumulation/typing/:audio_id',
    component: () => import('../components/accumulation/typing/typing.vue'),
    meta: { requiresAuth: false, title: '趣英语' ,favicon: '/qulogo-s.png'},
  },
  //H5扫码听音频
  {
    path: '/audioplayer/:id',
    component: () => import('../components/accumulation/pub/AudioPlayer.vue'),
    meta: { requiresAuth: false, title: '音频播放' ,favicon: '/audio_favicon.jpg'},
  },
  // H5电子书阅读器
  {
    path: '/bookreader/:id',
    component: () => import('../components/accumulation/booklist/BookReader.vue'),
    meta: { requiresAuth: false, title: '电子书阅读' },
  },
  // 磐诺管理后台 manage
  {
    path: '/manage',
    component: () => import('../components/manage/Manage.vue'),
    meta: { requiresAuth: true, title: '磐诺后台管理系统' },
    children: [
      {
        path: '/manage/MapView',
        component: () => import('../components/manage/MapView.vue'), 
        meta: { requiresAuth: true, title: '磐诺后台管理系统' },
      },
      {
        path: '/manage/SceneList',
        component: () => import('../components/manage/SceneList.vue'), 
        meta: { requiresAuth: true, title: '场景列表' },
      },
      {
        path: '/manage/SceneCollection',
        component: () => import('../components/manage/SceneCollection.vue'), 
        meta: { requiresAuth: true, title: '精选场景' },
      }
    ],
  },
  //Platform
  {
    path: '/platform',
    component: () => import('../components/platform/Platform.vue'),
    meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
    children: [
      {
        path: 'map',
        component: () => import('../components/platform/map/Map.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      },
      {
        path: 'mylist',
        component: () => import('../components/platform/mylist/SceneList.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      },
      {
        path: 'mycollection',
        component: () => import('../components/platform/mycollection/SceneCollection.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      },
      {
        path: 'userlist',
        component: () => import('../components/platform/userlist/UserList.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      },
      {
        path: 'rolelist',
        component: () => import('../components/platform/userlist/RoleList.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      },
      {
        path: 'menulist',
        component: () => import('../components/platform/userlist/MenuList.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      },
      {
        path: 'scenelist',
        component: () => import('../components/platform/scenelist/SceneList.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      },
      {
        path: 'collectionlist',
        component: () => import('../components/platform/collectionlist/SceneCollection.vue'), 
        meta: { requiresAuth: true, title: '磐诺全景 ★无人机全景导览~' },
      }
    ],
    redirect: '/platform/map', 
  },
  {
    path: '/platform/login',
    component: () => import('../components/platform/Login.vue'),
    meta: { requiresAuth: false, title: '磐诺全景 ★无人机全景导览~' },
  },
  {
    path: '/quxuexi',
    // 已删除 qulearning 相关路由
    redirect: '/',
  },
  // 404 页面
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../components/NotFound.vue'),
  },
  // 微信 H5
  {
    path: '/pano/:sceneId/:openId?', // 增加 openId 参数，且设置为可选参数
    component: () => import('../components/Pano.vue'),
    meta: { fullScreen: true, title: '磐诺全景 ★无人机全景导览~' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const store = useStore(); // 获取 Vuex store
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = store.getters.isAuthenticated; // 从 Vuex 的 getters 中获取认证状态

  if (requiresAuth && !isAuthenticated) {
    // 如果需要登录，但用户未登录，根据访问的路径跳转到对应的登录页面
    let loginPath;
    if (to.path.startsWith('/accumulation')) {
      loginPath = '/accumulation/login';
    } else if (to.path.startsWith('/platform')) {
      loginPath = '/platform/login';
    } else if (to.path.startsWith('/quxuexi')) {
      loginPath = '/quxuexi';
    } else {
      loginPath = '/login'; // 默认跳转到根路径的登录页面
    }
    next({ path: loginPath });
  } else if (requiresAuth && isAuthenticated) {
    // 如果需要登录且用户已登录，检查JWT是否过期
    const token = store.state.token;
    
    if (!token) {
      // 如果没有token，清除认证状态并跳转到登录页
      store.dispatch('logout');
      let loginPath;
      if (to.path.startsWith('/accumulation')) {
        loginPath = '/accumulation/login';
      } else if (to.path.startsWith('/platform')) {
        loginPath = '/platform/login';
      } else if (to.path.startsWith('/quxuexi')) {
        loginPath = '/quxuexi';
      } else {
        loginPath = '/login';
      }
      next({ path: loginPath });
      return;
    }
    
    try {
      const decoded = jwt_decode(token);
      const currentTime = Date.now() / 1000; // 当前时间（秒）

      if (decoded.exp < currentTime) {
        // JWT过期
        store.dispatch('logout'); // 清除JWT
        let loginPath;
        if (to.path.startsWith('/accumulation')) {
          loginPath = '/accumulation/login';
        } else if (to.path.startsWith('/platform')) {
          loginPath = '/platform/login';
        } else if (to.path.startsWith('/quxuexi')) {
          loginPath = '/quxuexi';
        } else {
          loginPath = '/login'; // 默认跳转到根路径的登录页面
        }
        next({ path: loginPath, query: { redirect: to.fullPath } }); // 跳转到登录页面，并保留当前路径
      } else {
        // 设置页面标题
        if (to.meta && to.meta.title) {
          document.title = to.meta.title;
        }

        // 设置 favicon
        if (to.meta && to.meta.favicon) {
          const faviconLink = document.querySelector('link[rel="icon"]');
          if (faviconLink) {
            faviconLink.href = to.meta.favicon;
          }
        }

        // 其他情况正常跳转
        next();
      }
    } catch (error) {
      // JWT解析失败，清除认证状态并跳转到登录页
      console.error('JWT解析失败:', error);
      store.dispatch('logout');
      let loginPath;
      if (to.path.startsWith('/accumulation')) {
        loginPath = '/accumulation/login';
      } else if (to.path.startsWith('/platform')) {
        loginPath = '/platform/login';
      } else if (to.path.startsWith('/quxuexi')) {
        loginPath = '/quxuexi';
      } else {
        loginPath = '/login';
      }
      next({ path: loginPath });
    }
  } else {
    // 设置页面标题
    if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    }

    // 设置 favicon
    if (to.meta && to.meta.favicon) {
      const faviconLink = document.querySelector('link[rel="icon"]');
      if (faviconLink) {
        faviconLink.href = to.meta.favicon;
      }
    }

    // 其他情况正常跳转
    next();
  }
});

export default router;